import agent from './agent';
import { push } from 'react-router-redux';
import ACTS from './constants';

const promiseMiddleware = store => next => action => {
  if (isPromise(action.payload)) { // api 요청건
    store.dispatch({ type: ACTS.ASYNC_START });

    action.payload.then(
      res => {        
        if(res && res.code !== '0000' && !res.length) {
          action.error = true;
          if(res.message) window.Alert.info(res.message);
        }

        if(action.resolve) action.resolve(); // 로딩 제거

        action.payload = res;
        store.dispatch({ type: ACTS.ASYNC_END, promise: action.payload });
        store.dispatch(action);
      },
      error => {
        action.error = true;
        action.payload = error;

        if(action.resolve) action.resolve(); // 로딩 제거
        
        if(error.message) window.Alert.info(error.message);

        if (!action.skipTracking) {
          store.dispatch({ type: ACTS.ASYNC_END, promise: action.payload });
        }
        store.dispatch(action);
      }
    );

    return;
  }

  next(action); 
};

const localStorageMiddleware = store => next => action => {  
  if (action.type === ACTS.LOGIN) {
    if (action.payload.result) {
      agent.setToken(action.payload.accessToken);
      agent.setInfo(action.payload.info);
      
      if(action.redirect) store.dispatch(push('/main?start'));      
    }else{
      window.Alert.info(action.payload.message);
    }

  } else if (action.type === ACTS.LOGOUT) {
    agent.clearAuth();
        
  }

  next(action);
};

const authMiddleware = store => next => action => {
  next(action);
}

function isPromise(v) {
  return v && typeof v.then === 'function';
}


export { promiseMiddleware, localStorageMiddleware, authMiddleware }


// WEBPACK FOOTER //
// ./src/middleware.js